<template>
  <div class="container CapacityListMaintain">
    <div class="action-btn-row">
      <el-button size="mini" class="btn" type="primary" @click="saveTemplate">{{$t('common.saveDraft')}}</el-button>
      <!--保存-->
      <el-button size="mini" class="btn" type="primary" @click="submitTemplate">{{$t('common.submit')}}</el-button>
      <!--提交-->
      <el-button size="mini" class="btn" type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
    </div>
    <el-card class="box-card">
      <!--基础信息维护-->
      <div slot="header" class="clearfix">
        <span>{{$t('capacity.baseInfoMaintain')}}（{{$t('capacity.most20')}}）</span>
      </div>
      <div class="action-btn-row">
        <el-button size="mini" type="primary" v-if="headList.length<20" @click="addBaseInfo()">{{$t('common.add')}}</el-button>
        <!-- <el-button type="danger" size="mini" @click="delBaseInfo()">{{$t('common.del')}}</el-button> -->
      </div>
      <el-table :data="headList" ref="headList" border highlight-current-row class="headList">
        <!-- <el-table-column fixed sortable :selectable="(row, index)=>index != 0" type="selection" width="55" align="center"></el-table-column> -->
        <el-table-column show-overflow-tooltip prop='name' :label="$t('common.name')">
          <template slot-scope="scope">
            <el-input class="handle-input" v-model="scope.row.name" clearable :disabled='scope.$index==0 || scope.$index==1'></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.linePrice.operation')" width="50">
          <template slot-scope="scope">
            <div class="a-link" v-if="scope.$index != 0 && scope.$index!=1" @click="delBaseInfo(scope.$index)">{{$t('common.del')}}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card class="box-card">
      <!--年度循环调查信息维护-->
      <el-form label-width="120px" ref="investigateForm" :model="investigateForm" inline :rules="investigateRules">
        <!-- <el-form-item :label="$t('capacity.beginYear')" prop="beginYear">
                    循环开始时间
                    <el-date-picker v-model="investigateForm.beginYear" type="year" clearable value-format="yyyy" :placeholder="$t('capacity.selectYear')"></el-date-picker>
                </el-form-item> -->
        <el-form-item :label="$t('capacity.severalYears')" prop="severalYears">
          <!-- 设置循环年限 -->
          <el-select v-model="investigateForm.severalYears" clearable :placeholder="$t('common.sel')">
            <el-option :label="$t('capacity.clearable1')" value="1"> </el-option>
            <el-option :label="$t('capacity.clearable2')" value="2"> </el-option>
            <el-option :label="$t('capacity.clearable3')" value="3"> </el-option>
            <el-option :label="$t('capacity.clearable4')" value="4"> </el-option>
            <el-option :label="$t('capacity.clearable5')" value="5"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="header" class="clearfix">
        <span>{{$t('capacity.yearLoopMaintain')}}（{{$t('capacity.most8')}}）</span>
      </div>
      <div class="action-btn-row">
        <el-button type="primary" size="mini" v-if="footList.length<8" @click="addfootList()">{{$t('common.add')}}</el-button>
        <!-- <el-button type="danger" size="mini" @click="delfootList()">{{$t('common.del')}}</el-button> -->
      </div>
      <el-table :data="footList" ref="footList" border highlight-current-row class="headList">
        <!-- <el-table-column fixed sortable :selectable="(row, index)=>index != footList.length-1" type="selection" width="55" align="center"></el-table-column> -->
        <el-table-column show-overflow-tooltip :label="$t('common.name')">
          <template slot-scope="scope">
            <el-input class="handle-input" v-model="scope.row.name" clearable :disabled='scope.$index==1'></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.linePrice.operation')" width="50">
          <template slot-scope="scope">
            <div class="a-link" v-if="!(scope.$index == 0 || scope.$index == 1)" @click="delfootList(scope.$index)">{{$t('common.del')}}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>

</template>

<script>
import IcSelect from "@/components/common/icSelect";
import { fileService } from "@/api/common/file-utils";
import capacityApi from "@/api/capacity/capacity";
export default {
  components: { IcSelect },
  data() {
    return {
      headList: [],
      footList: [],
      investigateForm: { severalYears: '' },
      // investigateForm:{beginYear:'',severalYears:''},
      TemplateInfo: {},
      investigateRules: {
        // beginYear: [ { required: true, message: this.$t("visitPlan.noEmpty"), trigger: "blur"},],
        severalYears: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: "change" },],
      },
      status: '',
    }
  },
  created() {
    this.supplierCode = this.$route.query.supplierCode;
    this.initializeTemplateInfo();
  },
  methods: {
    initializeTemplateInfo() {//初始化模版
      let that = this
      capacityApi.getTemplate().then(res => {
        that.TemplateInfo = res.data
        let headList = res.data.head
        let footList = res.data.foot
        headList.forEach(row => {
          that.headList.push({ "name": row });
        });
        footList.forEach(row => {
          that.footList.push({ "name": row });
        });
        // if(res.data.beginYear){
        //     that.investigateForm.beginYear = res.data.beginYear.toString()
        // }
        if (res.data.severalYears) {
          that.investigateForm.severalYears = res.data.severalYears
        }
        that.status = res.data.status
      });
    },
    saveTemplate() {
      let that = this
      let head = []
      this.headList.forEach(row => {
        head.push(row.name);
      });
      let foot = []
      this.footList.forEach(row => {
        foot.push(row.name);
      });
      let data = {
        // beginYear:that.investigateForm.beginYear,
        severalYears: that.investigateForm.severalYears,
        head: head,
        foot: foot,
        submit: false,
        ttTemplateId: this.TemplateInfo.ttTemplateId,
        status: this.TemplateInfo.status,
        hasHistory: this.TemplateInfo.hasHistory,
      }
      console.log(data)
      capacityApi.saveTemplate(data).then(res => {
        if (res.code == 200) {
          that.$message({
            message: this.$t("common.saveSuccess"),
            type: "success"
          });
          that.AfterSuccess(res.data)
        }
      });
    },
    submitTemplate() {
      let that = this
      this.$refs.investigateForm.validate(valid => {
        if (valid) {
          let head = []
          this.headList.forEach(row => {
            head.push(row.name);
          });
          let foot = []
          this.footList.forEach(row => {
            foot.push(row.name);
          });
          let data = {
            // beginYear:that.investigateForm.beginYear,
            severalYears: that.investigateForm.severalYears,
            head: head,
            foot: foot,
            submit: true,
            ttTemplateId: this.TemplateInfo.ttTemplateId,
            status: this.TemplateInfo.status,
            hasHistory: this.TemplateInfo.hasHistory,
          }
          console.log(data)
          capacityApi.saveTemplate(data).then(res => {
            if (res.code == 200) {
              that.$message({
                message: this.$t("common.submitSuccess"),
                type: "success"
              });
              that.AfterSuccess(res.data)
            }
          });
        } else {
          return false;
        }
      });
    },
    AfterSuccess(data) {
      let that = this
      that.headList = []
      that.footList = []
      that.TemplateInfo = data
      let headList = data.head
      let footList = data.foot
      headList.forEach(row => {
        that.headList.push({ "name": row });
      });
      footList.forEach(row => {
        that.footList.push({ "name": row });
      });
      // if(data.beginYear){
      //     that.investigateForm.beginYear = data.beginYear.toString()
      // }
      if (data.severalYears) {
        that.investigateForm.severalYears = data.severalYears
      }
      that.status = data.status
    },
    //添加基础信息维护
    addBaseInfo() {
      this.headList.push({ name: '' })
    },
    addfootList() {
      this.footList.push({ name: '' })
      // this.footList.unshift({name:''})
    },
    delBaseInfo(index) {
      // debugger
      let list = this.headList;
      list.splice(index, 1);
    },
    delfootList(index) {
      let list = this.footList;
      list.splice(index, 1);
      // let that = this
      // let val = this.$refs.footList.selection;
      // let list = this.footList;
      // if (val.length == 0) {
      //     that.$message({ message: that.$t("common.pleaseSelectData"), type: "warning" });
      //     return;
      // }else{
      //     val.forEach(function(item, index) {
      //         list.forEach(function(itemI, indexI) {
      //             // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
      //             if (index === indexI) {
      //                 list.splice(indexI, 1);
      //             }
      //         });
      //     });
      // }
      //1、定义：完结所有项目管理过程的所有活动，正式结束项目或阶段。结束项目也叫项目收尾、行政收尾、阶段收尾。
      // 项目有明确的起点和终点，起点是项目章程获得批准。终点是：
      // 1）目标达成
      // 2）不能达到目标项目终止
      // 3）项目需求不复存在
      // 4）客户或发起人希望终止等等
      // 如果项目在完工前就提前终止，本过程还需制定程序，来调查和记录提前终止的原因
    },
    historyBack: function () {
      this.$router.push({
        path: `/capacity`,
      });
    },
  }

}
</script>
<style lang="scss">
.CapacityListMaintain {
  .headList {
    width: 400px;
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: "";
  }
}
</style>
